import { render, staticRenderFns } from "./RelatorioOrientacao.vue?vue&type=template&id=5b2f164b&"
import script from "./RelatorioOrientacao.vue?vue&type=script&lang=js&"
export * from "./RelatorioOrientacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports